module.exports = __webpack_public_path__ + "static/media/auditorium-poster.7746c1e8.jpg";